import { render, staticRenderFns } from "./PaymentRequisitionListPage.vue?vue&type=template&id=34787c4b&"
import script from "./PaymentRequisitionListPage.vue?vue&type=script&lang=ts&"
export * from "./PaymentRequisitionListPage.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentRequisitionListPage.vue?vue&type=style&index=0&id=34787c4b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports